import type { RequisitionCancellationRequest } from '@/api/typings/transaction.typing'

export const hasPendingCancellation = (requests?: RequisitionCancellationRequest[] | null): boolean =>
  !!requests?.some((request) => request.status === 'PENDING')
